import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/account/admin/account-parameter`;

export const accountParameterService = {
    createAccountParameter: async function (params: any) {
        return axios.post(`${GATEWAY_URL}/create-account-parameter`, params)
            .then((response) => {
                return response.data;
            });
    },
    updateAccountParameter: async function (key: any, params: any) {
        return axios.put(`${GATEWAY_URL}/update-account-parameter`, params)
            .then((response) => {
                return response.data;
            });
    },
    deleteAccountParameter: async function (params: any) {
        console.log(params)
        return axios.delete(`${GATEWAY_URL}/delete-account-parameter`, {
            params
        }).then((response) => {
            return response.data;
        });
    },
    getAccountParameters: async function (loadOptions: any) {
        const params = processLoadOptions(loadOptions);
        return axios.get(`${GATEWAY_URL}/get-account-parameters`, {
            params
        }).then((response) => {
            return response.data;
        });
    },
    lookupAccountParameters: async function (loadOptions: any) {
        const params = processLoadOptions(loadOptions);
        return axios.get(`${GATEWAY_URL}/lookup-account-parameter-types`, {
            params
        })
            .then((response) => {
                return response.data;
            });
    },
    getAccountParameterType: async function (id: any) {
        return axios.get(`${GATEWAY_URL}/get-account-parameter-type`, {
            params: { Id: id }
        })
            .then((response) => {
                return response.data;
            });
    }
}